import {State} from '../index'

export const getAuthState = (state: State) => state.auth

export const getRefreshedToken = (state: State) => getAuthState(state).refreshedToken
